// import * as firebase from "firebase";
import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/messaging";

const sgcmConfig = {
    apiKey: "AIzaSyAe0xyxRXV5-gYXIrmGVTfPgGDXAX73tHk",
  authDomain: "priorcash-1cfd9.firebaseapp.com",
  projectId: "priorcash-1cfd9",
  storageBucket: "priorcash-1cfd9.firebasestorage.app",
  messagingSenderId: "601082204387",
  appId: "1:601082204387:web:7ce2bfa57e31203498b5d6",
  measurementId: "G-BNNC82E2LF"

//  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
//  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
//  projectId: process.env.REACT_APP_FIREBASE_PRFOJECTID,
//  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
//  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGESENDERID,
//  appId: process.env.REACT_APP_FIREBASE_APPID,
//  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

export default firebase.initializeApp(sgcmConfig);



// WEBPACK FOOTER //
// ./src/firebase-config.js